(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.eubasicContact === "undefined") {
        jQuery.extend(sm.portal.vm, { eubasicContact: {} });
    }

    function LoadModel(basicContact, container){
        basicContact.PermanentMailingAddress(new sm.portal.vm.MailingAddressViewModel());
        basicContact.PermanentMailingAddress().setType('permanent');
        basicContact.PrimaryMailingAddress().setType('correspondence');
        basicContact.PermanentMailingAddress().LoadModel(container);

        // apply contry name change subscriptions
        jQuery.each([basicContact.PrimaryMailingAddress()], function (k, control) {
            // subscribe to the control
            control.SelectedCountryID.subscribe(function () {
                // set the default address format is if there is one   
                control.SelectedTemplateID(basicContact.getDefaultAddressFormatId(control));
            }, this);
        });

        // subscribe to correspondence address checkbox
        basicContact.PrimaryMailingAddress().useMailingAddress.subscribe(function(checked) {
            basicContact.showPermanentMailingAddress(!checked);

            if (!checked) {
                jQuery.each([basicContact.PermanentMailingAddress()], function(k, control) {
                    // subscribe to the control
                    control.SelectedCountryID.subscribe(function() {
                        // set the default address format is if there is one   
                        control.SelectedTemplateID(basicContact.getDefaultAddressFormatId(control));
                    }, this);
                });

                if (basicContact.PermanentMailingAddress().SelectedCountryID() == undefined || basicContact.PermanentMailingAddress().SelectedCountryID() == null) {
                    basicContact.PermanentMailingAddress().SelectedCountryID(basicContact.PrimaryMailingAddress().SystemCountry().ID());
                }

                if (container.Payload.BasicContactPrep != null) {
                    basicContact.PermanentMailingAddress().AddressGID(container.Payload.BasicContactPrep.PermanentAddressGID);
                }
            } 
        });

        if (container.Payload.BasicContact != null) {
            if (!sm.portal.utility.isNullOrEmpty(container.Payload.BasicContact.PermanentMailingAddress)) {
                // load permanent address
                basicContact.PermanentMailingAddress().LoadAddressModel(container.Payload.BasicContact.PermanentMailingAddress);
                basicContact.PermanentMailingAddress().SelectedCountryID(container.Payload.BasicContact.PermanentMailingAddress.CountryID);

                // load permanent address contry template
                basicContact.selectCountryTemplate(
                    basicContact.PermanentMailingAddress(),
                    container.Payload.BasicContact.PermanentMailingAddress.MailingAddressTemplateID
                );
            }
            basicContact.PrimaryMailingAddress().useMailingAddress(sm.portal.utility.isNullOrEmpty(container.Payload.BasicContact.PermanentMailingAddress));
        }
        
    }

    function ExtractATO(basicContact, returnObject){
        var stdPermanentAddress = null;

        if (basicContact.PermanentMailingAddress != undefined && basicContact.PermanentMailingAddress != null) {
            stdPermanentAddress = basicContact.PermanentMailingAddress().ExtractATO();
        }

        returnObject.PermanentAddress = stdPermanentAddress;
    }

    function Completed(basicContact){
        if ( basicContact.showPermanentMailingAddress() && !basicContact.PermanentMailingAddress().IsVMValid()){
            return false;
        }
        return true;
    }

    jQuery.extend(true, sm.portal.vm.eubasicContact, {
        LoadModel: LoadModel,
        ExtractATO: ExtractATO,
        Completed: Completed
    });

})(jQuery);